module.exports = __webpack_public_path__ + "static/media/Bell.f03cfaa8.mp3";